export default __webpack_public_path__ + "static/V2-Carton-MineralSwimBagNew-5d917fc76fa0dc58735e4a783b531d84.png";